(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      /* RYŌHŌ 2026-08-02 — --header-height ne doit JAMAIS être périmée.
         .shopify-section-header-hidden rétracte le header de calc(-1 * var(--header-height)).
         Dawn ne mesure cette hauteur qu'une seule fois, au connectedCallback. Si la hauteur
         réelle augmente ensuite (swap des polices, logo décodé après coup, bandeau d'annonces
         qui passe sur deux lignes, rotation de l'écran), la rétractation devient trop courte
         et le header reste FIGÉ, coupé à l'écran. On remesure donc à chaque changement. */
      this.boundSetHeaderHeight = this.scheduleHeaderHeight.bind(this);
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.boundSetHeaderHeight);
        this.resizeObserver.observe(this.header);
      }
      window.addEventListener('resize', this.boundSetHeaderHeight, { passive: true });
      window.addEventListener('orientationchange', this.boundSetHeaderHeight, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.boundSetHeaderHeight);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      /* createObserver() n'est plus appelé : son callback IntersectionObserver
         s'exécutait APRÈS connectedCallback et écrasait le headerBounds fiable calculé
         par setHeaderHeight() avec un intersectionRect potentiellement nul. */
    }

    setHeaderHeight() {
      const rect = this.header.getBoundingClientRect();
      const height = rect.height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      /* headerBounds sert de seuil dans onScroll. Dawn le renseignait depuis un
         IntersectionObserver à usage unique qui renvoie un rectangle NUL quand le header
         n'est pas visible au moment de la mesure (page rechargée en cours de défilement) :
         headerBounds tombait à {0,0} et la branche de réinitialisation d'onScroll
         devenait inatteignable — le header restait collé même revenu tout en haut.
         On le calcule ici depuis la position réelle. getBoundingClientRect + scrollY
         plutôt qu'offsetTop, dont la valeur n'est pas fiable sur un élément sticky collé. */
      /* headerBounds ne peut être mesuré que header NON collé : une fois `position: sticky`
         accroché, rect.top vaut 0 (ou -height quand il est rétracté) quel que soit le
         défilement. Comme cette fonction est aussi branchée sur `resize`, et qu'iOS émet
         des resize EN PLEIN défilement (repli de la barre d'URL), on recalculerait
         headerBounds.top = scrollY courant : au geste suivant vers le haut, la branche de
         réinitialisation d'onScroll se déclencherait et le header disparaîtrait en pleine
         remontée. On ne rafraîchit donc les bornes que lorsque la mesure est valide. */
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        const top = rect.top + window.scrollY;
        this.headerBounds = { top: top, bottom: top + height };
      }
    }

    /* resize et orientationchange partent en rafale sur iOS (barre d'URL qui se replie
       pendant le défilement) et setHeaderHeight force deux reflows. On regroupe. */
    scheduleHeaderHeight() {
      if (this.headerRaf) return;
      this.headerRaf = requestAnimationFrame(() => {
        this.headerRaf = null;
        this.setHeaderHeight();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.boundSetHeaderHeight);
      window.removeEventListener('orientationchange', this.boundSetHeaderHeight);
      this.mediaQuery?.removeEventListener('change', this.onMediaChange);
      if (this.headerRaf) cancelAnimationFrame(this.headerRaf);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
